import React, { useState, useEffect } from 'react';
import axios from "axios";


function formatDate(dateString) {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
}

export default function DeadlineCategory({ deadlineCategoryId, sessionId, renderDescription = false, renderTransmittalDate = false, renderReturnOffsetDay = false }) {
    const [deadlineCategory, setDeadlineCategory] = useState(null);
    const [foundReturnOffsetCalendarDay, setFoundReturnOffsetCalendarDay] = useState(null);
    const [foundTransmittalOffsetCalendarDay, setFoundTransmittalOffsetCalendarDay] = useState(null);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchDeadlineCategoryData(deadlineCategoryId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/deadlineCodes/${deadlineCategoryId}` );
            return response.data;
        } catch (error) {
            console.error("Error fetching deadline category data: ", error);
            throw error;
        }
    }

    async function fetchLegislativeCalendarDayById(deadlineCategoryId, sessionId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislativeCalendarDays/findBySessionId?sessionId=${sessionId}` );
            return response.data;
        } catch (error) {
            console.error("Error fetching deadline category data: ", error);
            throw error;
        }
    }

    useEffect(() => {
        async function loadData() {
            if (!deadlineCategoryId) {
                setDeadlineCategory(null);
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const data = await fetchDeadlineCategoryData(deadlineCategoryId);
                setDeadlineCategory(data);

                if(!renderDescription) {
                    const calendarData = await fetchLegislativeCalendarDayById(deadlineCategoryId, sessionId);
                    const foundReturnOffsetCalendarDay = calendarData.find(entry => entry.calendarDay === data.returnOffsetDay);
                    const foundTransmittalOffsetCalendarDay = calendarData.find(entry => entry.calendarDay === data.transmitOffsetDay);
                    setFoundReturnOffsetCalendarDay(foundReturnOffsetCalendarDay);
                    setFoundTransmittalOffsetCalendarDay(foundTransmittalOffsetCalendarDay);
                }
            } catch (err) {
                console.error("Error loading data:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        }
        loadData();
    }, [deadlineCategoryId, sessionId]);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!deadlineCategory) return <span>{deadlineCategoryId || ''}</span>;

    let transmittalDate;
    let returnOffsetDay;
    if(!renderDescription) {
        if (renderTransmittalDate) {
            transmittalDate = foundTransmittalOffsetCalendarDay.calendarDate;
        }
        if (renderReturnOffsetDay) {
            returnOffsetDay = foundReturnOffsetCalendarDay.calendarDate;
        }
    }

    return (
        <div>
            {renderDescription && <span>{deadlineCategory.description}</span>}
            {renderReturnOffsetDay && <span>{formatDate(returnOffsetDay)}</span>}
            {renderTransmittalDate && <span>{formatDate(transmittalDate)}</span>}
        </div>
    );
}
